import {Link} from "types/Link";
import {dateTime} from "services/date";

/**
 * Transform the given link by deserializing object properties
 *
 * @internal
 * @param link
 */
export default function deserializeLink(link: any): Link {
    link.featured_at = dateTime(link.featured_at)
    link.published_at = dateTime(link.published_at)
    link.created_at = dateTime(link.created_at)
    link.updated_at = dateTime(link.updated_at)

    return link;
}